import { SvgIcon, SvgIconProps } from "@mui/material";

const FigmaLinkIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24" width="18" height="18">
    <path
      d="M9.99 20.92C8.61 20.92 7.22 20.39 6.16 19.33C4.05 17.22 4.05 13.78 6.16 11.68C6.4 11.43 6.8 11.43 7.04 11.68C7.28 11.92 7.28 12.32 7.04 12.56C5.42 14.18 5.42 16.83 7.04 18.45C8.67 20.08 11.31 20.08 12.93 18.45C13.72 17.67 14.15 16.62 14.15 15.5C14.15 14.39 13.72 13.34 12.93 12.55C12.69 12.31 12.69 11.91 12.93 11.67C13.17 11.43 13.57 11.43 13.82 11.67C14.84 12.69 15.4 14.05 15.4 15.5C15.4 16.95 14.83 18.31 13.82 19.33C12.77 20.39 11.38 20.92 9.99 20.92Z"
      fill="currentColor"
    />
    <path
      d="M18.39 14.8C18.23 14.8 18.07 14.74 17.95 14.62C17.71 14.38 17.71 13.98 17.95 13.73C19.66 12.03 19.66 9.25 17.95 7.55C16.24 5.84 13.47 5.84 11.77 7.55C10.94 8.38 10.48 9.48 10.48 10.64C10.48 11.81 10.94 12.91 11.77 13.73C12.01 13.98 12.01 14.38 11.77 14.62C11.52 14.86 11.12 14.86 10.88 14.62C9.82 13.56 9.23 12.14 9.23 10.64C9.23 9.14 9.82 7.73 10.88 6.67C13.07 4.48 16.64 4.48 18.84 6.67C21.03 8.86 21.03 12.43 18.84 14.63C18.72 14.74 18.55 14.8 18.39 14.8Z"
      fill="currentColor"
    />
  </SvgIcon>
);

export default FigmaLinkIcon;
